import type { IconData } from '@stacksjs/iconify-core'

export const comment: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M718 5q10 0 17 7t6 17v657q0 5-3 6t-7-1L579 538H23q-10 0-16-7t-7-16V29q0-10 7-17t16-7z\"/>",
  "width": 750,
  "height": 820,
  "viewBox": "0 0 750 820"
}

export default comment
